// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_firebase_compat_auth_dist_esm_index_esm_js":"96e28bc79921d53c","node_modules_firebase_compat_messaging_dist_esm_index_esm_js":"71b87f9e9be31de0","node_modules_stencil_core_internal_client_shadow-css_js":"4b80c49757c11d67"}[chunkId] + ".js";
};